export default __webpack_public_path__ + "static/media/list2.73c489c2.svg";